export default {
  UNKNOWN: 'unknown',
  FAILED: 'failed',
  PASSED: 'passed'
};
